import type { Assessment } from "@thalamos/haven-common";

type Submission = Assessment["submissions"][number];

/**
 * The most recent attempt, found by its number rather than its position, so the
 * order submissions arrive in is not something this depends on.
 */
export const latestSubmission = (
  assessment: Assessment,
): Submission | undefined =>
  assessment.submissions.reduce<Submission | undefined>(
    (latest, submission) =>
      latest === undefined || submission.number > latest.number
        ? submission
        : latest,
    undefined,
  );
